'use strict';

var _AnimatedNumber = require('./AnimatedNumber');

var _AnimatedNumber2 = _interopRequireDefault(_AnimatedNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _AnimatedNumber2.default;


//////////////////
// WEBPACK FOOTER
// /~/react-animated-number/build/index.js
// module id = 635
// module chunks = 0